export default "__VITE_ASSET__0bfcee2b__"